import React, { useEffect, useState } from 'react';

import { Box, Typography } from '@mui/material';
import Icon, { ColorVariant } from '@apigrowfinance/pbolt-icon';
import { useTheme } from '@apigrowfinance/pbolt-theme-provider';
import dayjs from 'dayjs';
import { RiTimeLine } from 'react-icons/ri';

import { useOperatorSession } from '@contexts/OperatorSeesionProvider';

const OperatorSessionMiniPanel = () => {
    const { theme } = useTheme();
    const { sessionStartTime } = useOperatorSession();
    const [time, setTime] = useState(dayjs());

    useEffect(() => {
        const interval = setInterval(() => setTime(dayjs()), 1000);
        return () => {
            clearInterval(interval);
        };
    }, []);
    // TODO transition on mount from a larger size to this size
    return (
        <Box
            sx={{
                zIndex: 10,
                borderRadius: 1,
                width: theme.spacing(9.5),
                height: theme.spacing(9.5),
                position: 'fixed',
                bottom: theme.spacing(3),
                backgroundColor: 'primary.main',
                ml: 'auto',
                right: theme.spacing(3.25),
            }}
            data-testid="operator-session-panel-mini">
            <Box
                m={1}
                display="flex"
                flexDirection="column"
                justifyContent="center"
                alignItems="center">
                <Icon colorVariant={ColorVariant.PaperMain}>
                    <RiTimeLine />
                </Icon>
                <Typography
                    color="primary.contrastText"
                    fontWeight="600"
                    data-testid="timer">
                    {`${dayjs
                        .duration(time?.diff(sessionStartTime))
                        .format('mm:ss')}`}
                </Typography>
            </Box>
        </Box>
    );
};

export default OperatorSessionMiniPanel;
